import Component from './new_password_request_form.vue'
export default Component
